export const AdAccountV4 = {
  keyFields: false,
  merge: true,
} as const;
